import makeStyles from "@mui/styles/makeStyles";
import { Theme } from "@mui/material/styles";
import { createStyles } from "@mui/styles";

const UserManagementStyles = makeStyles((theme: Theme) =>
    createStyles({
        headerInner: {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            paddingBottom: theme.spacing(3),
        },
        headerTitle: {
            fontSize: 24,
            fontWeight: 600,
        },
        bodyHeader: {
            padding: theme.spacing(2, 2, 1.5, 2),
        },
        intro: {
            fontSize: 16,
            color: theme.palette.secondary.main,
            marginBottom: theme.spacing(2),
        },
        toolbox: {
            display: "flex",
            alignItems: "flex-end",
            marginBottom: theme.spacing(1.5),
        },
        filtersWrapper: {
            flex: 1,
            display: "flex",
            alignItems: "flex-end",
            marginRight: theme.spacing(2),
            "& > div": {
                display: "flex",
                flex: 1,
                alignItems: "flex-start",
                flexDirection: "column",
            },
        },
        label: {
            fontSize: 14,
            fontWeight: 500,
            color: theme.palette.text.primary,
            marginBottom: theme.spacing(0.5),
        },
        filterByNameInput: {
            width: "100%",
            "& .MuiInputBase-input": {
                height: 22,
            },
            "& .MuiInputAdornment-root .MuiSvgIcon-root": {
                fontSize: 16,
            },
        },
        selectField: {
            width: "100%",
            "& .MuiSelect-select": {
                paddingTop: theme.spacing(2.7),
                paddingBottom: theme.spacing(2.7),
                "& .MuiChip-root": {
                    height: 20,
                    "& .MuiChip-label": {
                        fontSize: 10,
                        maxWidth: 160,
                        overflow: "hidden",
                        whiteSpace: "pre",
                        textOverflow: "ellipsis",
                        paddingLeft: theme.spacing(0.75),
                        paddingRight: theme.spacing(0.75),
                    },
                },
            },
            "& .MuiSelect-icon": {
                fontSize: 16,
                right: theme.spacing(2),
            },
        },
        filterPlaceholderLabel: {
            color: theme.palette.text.disabled,
        },
        invitationsButton: {
            height: theme.spacing(2),
            padding: 0,
            borderRadius: 0,
            minWidth: "auto",
            color: theme.palette.secondary.main,
            borderBottom: `1px solid ${theme.palette.secondary.main}`,
        },
        selectFilterPaper: {
            borderRadius: theme.spacing(4),
            border: `1px solid ${theme.palette.secondary.light}`,
            boxShadow: "0px 1px 3px 0px #0000001A, 0px 1px 2px 0px #0000000F",
            maxHeight: 400,
        },
        sectionTitle: {
            fontSize: 20,
            fontWeight: 600,
        },
        errorAlert: {
            justifyContent: "center",
        },
        errorIcon: {
            fontSize: 16,
            marginRight: theme.spacing(0.5),
            alignSelf: "center",
        },
        errorMessage: {
            fontSize: 16,
            fontWeight: 400,
            marginLeft: theme.spacing(0.5),
        },
        usersTable: {
            "& .MuiCheckbox-root": {
                padding: 0,
            },
        },
        selectButton: {
            padding: theme.spacing(0, 1),
            "&.Mui-disabled": {
                opacity: 0.6,
            },
        },
        tableHeader: {
            background: theme.palette.background.paleBlue,
            position: "relative",
            zIndex: 2,
            "& .MuiTableCell-root": {
                fontWeight: 700,
                borderBottom: `1px solid ${theme.palette.neutrals.main}`,
                padding: theme.spacing(1),
                "& .MuiCheckbox-root": {
                    padding: 0,
                },
                "& .MuiTypography-root": {
                    fontSize: 16,
                    fontWeight: 700,
                    color: theme.palette.text.primary,
                },
            },
        },
        cellWithSortButton: {
            display: "flex",
            alignItems: "center",
            marginLeft: -8,
        },
        sortButton: {
            fontSize: 14,
            color: theme.palette.neutrals.dark,
        },
        columnsButton: {
            color: theme.palette.button.active.to,
        },
        tableBody: {
            "& .MuiTableRow-root": {
                "&:hover": {
                    "& $addUserButton": {
                        opacity: "0.6 !important",
                        "&:hover": {
                            opacity: "1 !important",
                        },
                    },
                },
            },
            "& .MuiTableCell-root": {
                color: theme.palette.text.secondary,
                padding: theme.spacing(1),
                "&:nth-child(1)": {
                    lineHeight: 0,
                },
                "&:nth-child(2)": {
                    paddingLeft: theme.spacing(0.5),
                },
                "&[data-hidden='true']": {
                    display: "none",
                },
            },
        },
        functionSelectMenuItem: {
            "& .MuiListItemText-primary": {
                fontSize: 16,
                fontWeight: 400,
                color: theme.palette.text.primary,
            },
            "&.Mui-selected": {
                "& .MuiListItemText-primary": {
                    fontWeight: 700,
                },
            },
            "& .MuiChip-label": {
                maxWidth: 160,
                overflow: "hidden",
                whiteSpace: "pre",
                textOverflow: "ellipsis",
            },
        },
        selectMenuClear: {
            display: "flex",
            justifyContent: "flex-end",
            padding: theme.spacing(0, 3, 2, 3),
        },
        addUserButton: {
            fontSize: 18,
            opacity: 0,
            color: theme.palette.success.main,
        },
        removeUserButton: {
            "& .MuiSvgIcon-root": {
                fontSize: 18,
            },
            color: theme.palette.text.disabled,
            "&:hover": {
                color: theme.palette.error.main,
            },
        },
        expandableRow: {
            "& .MuiTableCell-root": {
                background: theme.palette.background.grey,
                padding: theme.spacing(0, 3),
                borderBottom: `1px solid ${theme.palette.neutrals.light}`,
            },
            "& .MuiTypography-root": {
                fontSize: 12,
                fontWeight: 600,
            },
        },
        toggleCloseBtn: {
            marginLeft: "auto",
            "& .MuiSvgIcon-root": {
                fontSize: 10,
                color: theme.palette.neutrals.dark,
            },
        },
        noDataWrapper: {
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            margin: theme.spacing(-5, 0, 4),
            "& .MuiTypography-root": {
                fontSize: 16,
                marginBottom: theme.spacing(2),
                "& + .MuiTypography-root": {
                    fontSize: 14,
                    color: theme.palette.text.secondary,
                    marginTop: theme.spacing(-1.5),
                },
            },
        },
        confirmationWrapper: {
            width: "100%",
            maxWidth: 612,
            background: theme.palette.common.white,
            padding: theme.spacing(2),
        },
    })
);

export default UserManagementStyles;
